import React, { Component } from "react";
import { BASE_URL, USER_ROLE_MAPPER } from "../../../static/constants";
import getToken from "../../../utils/getToken";
import { handleUnauthorizedError } from "utils/auth";
import Button from "@mui/material/Button";

import UserModal from "../UserModal";

import "./index.css";

import { withStyles } from "@mui/styles";
import Switch from "@mui/material/Switch";
import CustomTable from "components/common/table/CustomTable";
import { FormControlLabel } from "@mui/material";
import { showErrorToast, showSuccessToast } from "utils/toast";
import { MRT_GlobalFilterTextField as GlobalFilterTextField } from "material-react-table";
import { textFilter } from "utils/table";

const CustomSwitch = withStyles({
  switchBase: {
    color: "#FFFFFF !important",
    "&$checked": {
      color: "#94ba33 !important",
    },
    "&$checked + $track": {
      backgroundColor: "#000000",
      opacity: ".38 !important",
    },
  },
  checked: {},
  track: {
    backgroundColor: "#000000",
    opacity: ".38 !important",
  },
})(Switch);

const initialFormTouchedState = {
  name: false,
  email: false,
  password: false,
  passwordConfirm: false,
  role: false,
  accountArr: false,
  manufacturerArr: false,
  testUser: false,
};

class Table extends Component {
  constructor(props) {
    super(props);
    this.state = {
      switchLoading: false,
      selectedUser: {
        name: "",
        email: "",
        password: "",
        passwordConfirm: "",
        role: "",
        accountArr: [],
        manufacturerArr: [],
        isFollowingPhysician: false,
        isFollowingHospital: false,
        testUser: false,
        physicians: [],
        hospitals: [],
        secondary_roles: [],
      },
      isFormValid: true,
      userModalOpen: false,
      requestType: "PUT",
      userModalTitle: "Update User Information",
      modalType: "add",
      processing: false,
      columnData: [
        {
          header: "Name",
          accessorKey: "name",
          filterVariant: "text",
          filterFn: textFilter,
        },
        {
          header: "Manufacturer",
          accessorKey: "manufacturer",
          filterVariant: "text",
          filterFn: textFilter,
          Cell: ({ row }) => {
            const rowData = row?.original;
            const items = rowData.manufacturerArr.map((item, key) => (
              <div style={{ marginBottom: "10px" }} key={`manufacturer-${key}`}>
                {item}
              </div>
            ));

            let itemHtml = "None";
            if (rowData.manufacturerArr.length === 1) itemHtml = items;
            if (rowData.manufacturerArr.length > 1) itemHtml = "Multiple";
            return <div>{itemHtml}</div>;
          },
        },
        {
          header: "Email",
          accessorKey: "email",
          filterVariant: "text",
          filterFn: textFilter,
        },
        {
          header: "Accounts",
          accessorKey: "accounts",
          filterVariant: "text",
          filterFn: textFilter,
          Cell: ({ row }) => {
            const rowData = row?.original;

            const items = rowData.accountArr.map((item, key) => (
              <div key={key}>{item}</div>
            ));
            let itemHtml = "None";
            if (rowData.accountArr.length === 1) itemHtml = items;
            if (rowData.accountArr.length > 1) itemHtml = "Multiple";
            return <div>{itemHtml}</div>;
          },
        },
        {
          header: "Role",
          accessorKey: "role",
          filterVariant: "text",
          filterFn: textFilter,
          Cell: ({ row }) => USER_ROLE_MAPPER[row?.original?.role] || "—",
        },
        {
          header: "Active",
          accessorKey: "active",
          filterVariant: "boolean",
          enableColumnFilter: false,
          size: 60,
          Cell: ({ row }) => {
            const rowData = row?.original;

            return (
              <FormControlLabel
                onClick={(e) => {
                  e.stopPropagation();
                  this.handleSwitchChange(!e.target.checked, rowData.id);
                }}
                disabled={this.state.switchLoading}
                control={<CustomSwitch defaultChecked={rowData.active} />}
              />
            );
          },
        },
      ],
      formTouched: {
        ...initialFormTouchedState,
      },
    };

    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.closeUserModal = this.closeUserModal.bind(this);
    this.saveUser = this.saveUser.bind(this);
    this.handleSwitchChange = this.handleSwitchChange.bind(this);
    this.validateForm = this.validateForm.bind(this);
  }

  handleSwitchChange(active, id) {
    this.setState({
      switchLoading: true,
    });
    if (!active) {
      this.props.enableUserSubmit(id).then(() => {
        this.setState({
          switchLoading: false,
        });
      });
    } else {
      this.props.disableUserSubmit(id).then(() => {
        this.setState({
          switchLoading: false,
        });
      });
    }
  }

  handleEdit(rowData) {
    const selectedUser = Object.assign({}, rowData);
    this.setState({
      selectedUser,
      userModalOpen: true,
      requestType: "PUT",
      userModalTitle: "Update User Information",
      modalType: "edit",
    });
  }

  handleAdd() {
    this.setState({
      userModalOpen: true,
      requestType: "POST",
      userModalTitle: "Add New User",
      modalType: "add",
      selectedUser: {
        name: "",
        email: "",
        password: "",
        passwordConfirm: "",
        role: "",
        accounts: [],
        accountArr: [],
        manufacturer: [],
        manufacturerArr: [],
        secondary_roles: [],
        // physician: false,
      },
    });
  }

  handleUpdate(val, key) {
    const { selectedUser, formTouched } = this.state;
    selectedUser[key] = val;
    formTouched[key] = val?.length > 0 ? true : false;

    this.setState({
      selectedUser,
      formTouched,
    });
  }

  closeUserModal() {
    this.setState({
      userModalOpen: false,
      processing: false,
      isFormValid: true,
      formTouched: {
        ...initialFormTouchedState,
      },
    });
  }

  validateForm() {
    const { selectedUser } = this.state;

    return (
      selectedUser.name.length > 0 &&
      selectedUser.accountArr.length > 0 &&
      selectedUser.manufacturerArr.length > 0 &&
      selectedUser.role.length > 0 &&
      selectedUser.email.length > 0 &&
      selectedUser.password.length > 0 &&
      selectedUser.passwordConfirm?.length > 0 &&
      (!selectedUser.isFollowingPhysician ||
        selectedUser.physicians?.length > 0) &&
      (!selectedUser.isFollowingHospital || selectedUser.hospitals?.length > 0)
    );
  }

  saveUser(values) {
    this.setState({ processing: true });
    const { selectedUser, requestType } = this.state;
    const { getUsers } = this.props;
    const accounts = values.accountArr;
    const manufacturer = values.manufacturerArr;

    const payload = {
      _id: selectedUser.id,
      name: values.name?.trim(),
      prevName: selectedUser.prevName,
      role: values.role,
      accounts,
      manufacturer,
      password: values.password,
      email: values.email,
      testUser: values.testUser,
      isFollowingPhysician: values.isFollowingPhysician,
      followingPhysicians: values.physicians,
      isFollowingHospital: values.isFollowingHospital,
      followingHospitals: values.hospitals,
      secondary_roles: values.secondary_roles,
      isCliniiUser: values?.isCliniiUser || false,
    };

    if ([true, false].includes(values?.showHFReports)) {
      payload.showHFReports = values?.showHFReports;
    }

    if ([true, false].includes(values?.showRegularReports)) {
      payload.showRegularReports = values?.showRegularReports;
    }

    if ([true, false].includes(values?.myPatientsToggled)) {
      payload.myPatientsToggled = values?.myPatientsToggled;
    }

    if ([true, false].includes(values?.audited_reports)) {
      payload.audited_reports = values?.audited_reports;
    }

    if ([true, false].includes(values?.is_auditor)) {
      payload.is_auditor = values?.is_auditor;
    }

    fetch(`${BASE_URL}/admin/user`, {
      method: requestType,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
      body: JSON.stringify(payload),
    })
      .then(async (response) => {
        const data = await response.json();
        const unauthorized = handleUnauthorizedError(
          response.status,
          "/admin/user",
          data
        );
        return unauthorized || data;
      })
      .then((data) => {
        if (!data.error) {
          if (data.message) {
            if (
              data.message === "user successfully updated" ||
              data.message === "user successfully created"
            ) {
              this.setState(
                {
                  userModalOpen: false,
                },
                () => {
                  showSuccessToast(data.message);
                  getUsers();
                }
              );
            }
          }
        } else {
          throw Error(data.message);
        }
      })
      .catch((error) => {
        const errorStr = error.toString();
        if (errorStr === "Error: jwt malformed") {
          this.props.navigate("/login");
        }
        if (errorStr === "Error: jwt expired") {
          this.props.navigate("/login");
        }
        if (errorStr === "Error: Unauthorized") {
          this.props.navigate("/prohibited");
        }
        showErrorToast(errorStr);
      })
      .finally(() => {
        this.setState({ processing: false });
      });
  }

  render() {
    const {
      selectedUser,
      userModalOpen,
      userModalTitle,
      modalType,
      processing,
      isFormValid,
      formTouched,
    } = this.state;
    const { userProps, isLoading } = this.props;

    return (
      <div style={{ position: "relative" }}>
        {userModalOpen && (
          <UserModal
            selectedUser={selectedUser}
            userModalOpen={userModalOpen}
            handleUpdate={this.handleUpdate}
            closeUserModal={this.closeUserModal}
            saveUser={this.saveUser}
            title={userModalTitle}
            modalType={modalType}
            processing={processing}
            isFormValid={isFormValid}
            formTouched={formTouched}
          />
        )}
        {/* {userProps.userDataLoading && (
          <div style={{ padding: "50px 0", textAlign: "center" }}>
            <LoadingSpinner />
          </div>
        )} */}
        {
          // !userProps.userDataLoading && (
          <div id="userTable">
            <div className="trans-table__container">
              <CustomTable
                columns={this.state.columnData}
                data={userProps.userData}
                options={{
                  enableTopToolbar: true,
                  enableSorting: true,
                  positionGlobalFilter: "left",
                  state: {
                    isLoading,
                    showGlobalFilter: true,
                    showColumnFilters: true,
                  },
                  // defaultColumn: {
                  //   minSize: 20, //allow columns to get smaller than default
                  //   maxSize: 9001, //allow columns to get larger than default
                  //   size: 300, //make columns wider by default
                  // },
                  rowsPerPageOptions: [25, 50, 100],
                  renderTopToolbar: ({ table }) => (
                    <div
                      className="d-flex"
                      style={{
                        padding: "10px",
                        borderBottom: "1px solid #e0e0e0",
                        gap: "10px",
                      }}
                    >
                      <GlobalFilterTextField table={table} />
                      <Button
                        onClick={this.handleAdd}
                        size="small"
                        color="secondary"
                        variant="contained"
                      >
                        + Add User
                      </Button>
                    </div>
                  ),
                  muiTableBodyRowProps: ({ isDetailPanel, row }) => ({
                    onClick: () => {
                      this.handleEdit(row?.original);
                    },
                    sx: {
                      cursor: "pointer",
                      backgroundColor: isDetailPanel
                        ? "rgba(142, 157, 176, .1)"
                        : "#FFF",
                    },
                  }),
                }}
              />
            </div>
          </div>
          // )
        }
      </div>
    );
  }
}

export default Table;
